import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import Link from "@mui/material/Link";
import { Link as index_js_Link } from "../Link/index.js";
import { Icon } from "../Icon/index.js";
import { Box } from "../Box/index.js";
import { FilePreviewWithZoom } from "../FilePreviewWithZoom/index.js";
import { Dialog } from "../Dialog/index.js";
import { useIsDesktop, useIsTablet } from "../hooks/index.js";
import { CsvFileImage, DocFileImage, ExcelFileImage, OdsFileImage, OdtFileImage, P7mFileImage, UnknownFileImage, XmlFileImage } from "../graphics/index.js";
import { DownloadableFileIcon, PreviewImage, PreviewPdf, PreviewSnackbar } from "./Previews/index.js";
import { useStyles } from "./FilePreviewWrapper.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const FilePreviewContent = (t0)=>{
    var _blob_path, _blob_path1;
    const $ = c(115);
    const { shape: t1, onClickPrint, onClickDownload, onLoadSuccess, withCollapsableFooter, view: t2, showSnackbarOnDesktop: t3, snackbarMessage, snackbarAction, linkText, withFlex: t4, centerImage: t5, withZoom: t6, height, width, maxHeight, maxWidth, blob, blobType, objectUrl, onLoadFull, handleOpen, handleClose, clickable, open, alternativeImageComponent: t7 } = t0;
    const shape = void 0 === t1 ? "auto" : t1;
    const view = void 0 === t2 ? "file" : t2;
    const showSnackbarOnDesktop = void 0 === t3 ? false : t3;
    const withFlex = void 0 === t4 ? false : t4;
    const centerImage = void 0 === t5 ? false : t5;
    const withZoom = void 0 === t6 ? false : t6;
    const alternativeImageComponent = void 0 === t7 ? false : t7;
    let t8;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {
            mb: {},
            mt: {}
        };
        $[0] = t8;
    } else t8 = $[0];
    const { classes } = useStyles(t8);
    const isDesktop = useIsDesktop();
    const isTablet = useIsTablet();
    if ("application/pdf" === blobType) {
        let t9;
        if ($[1] !== handleOpen || $[2] !== linkText || $[3] !== objectUrl || $[4] !== onClickDownload || $[5] !== onLoadSuccess || $[6] !== shape || $[7] !== view) {
            t9 = "fileLarge" === view ? /*#__PURE__*/ jsxs(Box, {
                p: "24",
                py: "16",
                bgcolor: "bg.greyscale.primary",
                radius: "l",
                maxHeight: 400,
                overflow: "hidden",
                position: "relative",
                className: "aqa_file_preview_pdf_wrapper",
                children: [
                    /*#__PURE__*/ jsx(PreviewPdf, {
                        url: objectUrl,
                        shape: shape,
                        onClickDownload: onClickDownload,
                        onLoadSuccess: onLoadSuccess
                    }),
                    /*#__PURE__*/ jsx(Link, {
                        onClick: handleOpen,
                        children: /*#__PURE__*/ jsxs(Box, {
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            bgcolor: "bg.dark.primary",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            p: "12",
                            children: [
                                /*#__PURE__*/ jsx(Box, {
                                    color: "bg.light.primary",
                                    children: linkText
                                }),
                                /*#__PURE__*/ jsx(Box, {
                                    color: "bg.light.primary",
                                    children: /*#__PURE__*/ jsx(Icon, {
                                        name: "chevron_right_outline",
                                        size: "20"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ jsx(index_js_Link, {
                onClick: handleOpen,
                stroke: false,
                size: "small",
                children: linkText || "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440"
            });
            $[1] = handleOpen;
            $[2] = linkText;
            $[3] = objectUrl;
            $[4] = onClickDownload;
            $[5] = onLoadSuccess;
            $[6] = shape;
            $[7] = view;
            $[8] = t9;
        } else t9 = $[8];
        const links = t9;
        let t10;
        if ($[9] !== alternativeImageComponent || $[10] !== classes || $[11] !== clickable || $[12] !== handleClose || $[13] !== handleOpen || $[14] !== isDesktop || $[15] !== links || $[16] !== objectUrl || $[17] !== onClickDownload || $[18] !== onClickPrint || $[19] !== onLoadSuccess || $[20] !== open || $[21] !== shape || $[22] !== showSnackbarOnDesktop || $[23] !== snackbarAction || $[24] !== snackbarMessage || $[25] !== view || $[26] !== withCollapsableFooter || $[27] !== withZoom) {
            t10 = clickable ? /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    "file" === view ? /*#__PURE__*/ jsx(Box, {
                        className: `${classes.documentCursor} aqa_file_preview_pdf_wrapper`,
                        children: /*#__PURE__*/ jsx(PreviewPdf, {
                            url: objectUrl,
                            shape: shape,
                            onClickPrint: onClickPrint,
                            onOpen: handleOpen,
                            onClickDownload: onClickDownload,
                            withCollapsableFooter: withCollapsableFooter,
                            onLoadSuccess: onLoadSuccess
                        })
                    }) : links,
                    isDesktop && withZoom ? /*#__PURE__*/ jsx(FilePreviewWithZoom, {
                        onClose: handleClose,
                        open: open,
                        url: objectUrl,
                        onLoadSuccess: onLoadSuccess,
                        withBottomOffset: showSnackbarOnDesktop,
                        alternativeImageComponent: alternativeImageComponent
                    }) : /*#__PURE__*/ jsx(Dialog, {
                        scroll: "body",
                        onClose: handleClose,
                        open: open,
                        fullScreen: !isDesktop,
                        className: "aqa_file_preview_dialog",
                        classes: {
                            paper: classes.dialogPaper
                        },
                        withoutRadius: !isDesktop,
                        children: /*#__PURE__*/ jsx(PreviewPdf, {
                            url: objectUrl,
                            shape: "auto",
                            onLoadSuccess: onLoadSuccess,
                            onClickDownload: isDesktop ? void 0 : onClickDownload
                        })
                    }),
                    (showSnackbarOnDesktop || !isDesktop) && /*#__PURE__*/ jsx(PreviewSnackbar, {
                        open: open,
                        onClick: handleClose,
                        message: snackbarMessage,
                        action: snackbarAction
                    })
                ]
            }) : /*#__PURE__*/ jsxs(Box, {
                children: [
                    /*#__PURE__*/ jsx(PreviewPdf, _object_spread({
                        url: objectUrl,
                        shape: shape,
                        onClickPrint: onClickPrint,
                        onClickDownload: onClickDownload,
                        withCollapsableFooter: withCollapsableFooter,
                        onLoadSuccess: onLoadSuccess
                    }, withZoom && {
                        onExpand: handleOpen
                    })),
                    withZoom && isDesktop && /*#__PURE__*/ jsx(FilePreviewWithZoom, {
                        onClose: handleClose,
                        open: open,
                        url: objectUrl,
                        onLoadSuccess: onLoadSuccess,
                        withBottomOffset: showSnackbarOnDesktop
                    })
                ]
            });
            $[9] = alternativeImageComponent;
            $[10] = classes;
            $[11] = clickable;
            $[12] = handleClose;
            $[13] = handleOpen;
            $[14] = isDesktop;
            $[15] = links;
            $[16] = objectUrl;
            $[17] = onClickDownload;
            $[18] = onClickPrint;
            $[19] = onLoadSuccess;
            $[20] = open;
            $[21] = shape;
            $[22] = showSnackbarOnDesktop;
            $[23] = snackbarAction;
            $[24] = snackbarMessage;
            $[25] = view;
            $[26] = withCollapsableFooter;
            $[27] = withZoom;
            $[28] = t10;
        } else t10 = $[28];
        return t10;
    }
    if (null == blobType ? void 0 : blobType.startsWith("image/")) {
        let t9;
        if ($[29] !== centerImage || $[30] !== clickable || $[31] !== handleClose || $[32] !== handleOpen || $[33] !== height || $[34] !== maxHeight || $[35] !== maxWidth || $[36] !== objectUrl || $[37] !== onClickDownload || $[38] !== onLoadFull || $[39] !== onLoadSuccess || $[40] !== open || $[41] !== shape || $[42] !== showSnackbarOnDesktop || $[43] !== width || $[44] !== withCollapsableFooter || $[45] !== withZoom) {
            t9 = ()=>/*#__PURE__*/ jsxs(Fragment, {
                    children: [
                        /*#__PURE__*/ jsx(PreviewImage, _object_spread({
                            url: objectUrl,
                            shape: shape,
                            onLoadFull: onLoadFull,
                            clickable: !!clickable,
                            onClickDownload: onClickDownload,
                            withCollapsableFooter: withCollapsableFooter,
                            centerImage: centerImage,
                            onLoadSuccess: onLoadSuccess,
                            height: height,
                            width: width,
                            maxHeight: maxHeight,
                            maxWidth: maxWidth
                        }, withZoom && !clickable && {
                            onExpand: handleOpen
                        })),
                        withZoom && /*#__PURE__*/ jsx(FilePreviewWithZoom, {
                            onClose: handleClose,
                            open: open,
                            url: objectUrl,
                            onLoadFull: onLoadFull,
                            onLoadSuccess: onLoadSuccess,
                            withBottomOffset: showSnackbarOnDesktop,
                            fileType: "image"
                        })
                    ]
                });
            $[29] = centerImage;
            $[30] = clickable;
            $[31] = handleClose;
            $[32] = handleOpen;
            $[33] = height;
            $[34] = maxHeight;
            $[35] = maxWidth;
            $[36] = objectUrl;
            $[37] = onClickDownload;
            $[38] = onLoadFull;
            $[39] = onLoadSuccess;
            $[40] = open;
            $[41] = shape;
            $[42] = showSnackbarOnDesktop;
            $[43] = width;
            $[44] = withCollapsableFooter;
            $[45] = withZoom;
            $[46] = t9;
        } else t9 = $[46];
        const renderImage = t9;
        let t10;
        if ($[47] !== renderImage || $[48] !== withFlex) {
            t10 = withFlex ? /*#__PURE__*/ jsx(Box, {
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                children: renderImage()
            }) : renderImage();
            $[47] = renderImage;
            $[48] = withFlex;
            $[49] = t10;
        } else t10 = $[49];
        return t10;
    }
    if ("text/xml" === blobType || "application/xml" === blobType) {
        const t9 = isTablet ? 56 : 36;
        const t10 = isTablet ? 56 : 36;
        let t11;
        if ($[50] !== t10 || $[51] !== t9) {
            t11 = /*#__PURE__*/ jsx(XmlFileImage, {
                width: t9,
                height: t10
            });
            $[50] = t10;
            $[51] = t9;
            $[52] = t11;
        } else t11 = $[52];
        let t12;
        if ($[53] !== onClickDownload || $[54] !== shape || $[55] !== t11 || $[56] !== withCollapsableFooter) {
            t12 = /*#__PURE__*/ jsx(DownloadableFileIcon, {
                shape: shape,
                onClickDownload: onClickDownload,
                withCollapsableFooter: withCollapsableFooter,
                children: t11
            });
            $[53] = onClickDownload;
            $[54] = shape;
            $[55] = t11;
            $[56] = withCollapsableFooter;
            $[57] = t12;
        } else t12 = $[57];
        return t12;
    }
    if ("application/vnd.oasis.opendocument.text" === blobType) {
        const t9 = isTablet ? 56 : 36;
        const t10 = isTablet ? 56 : 36;
        let t11;
        if ($[58] !== t10 || $[59] !== t9) {
            t11 = /*#__PURE__*/ jsx(OdtFileImage, {
                width: t9,
                height: t10
            });
            $[58] = t10;
            $[59] = t9;
            $[60] = t11;
        } else t11 = $[60];
        let t12;
        if ($[61] !== onClickDownload || $[62] !== shape || $[63] !== t11 || $[64] !== withCollapsableFooter) {
            t12 = /*#__PURE__*/ jsx(DownloadableFileIcon, {
                shape: shape,
                onClickDownload: onClickDownload,
                withCollapsableFooter: withCollapsableFooter,
                children: t11
            });
            $[61] = onClickDownload;
            $[62] = shape;
            $[63] = t11;
            $[64] = withCollapsableFooter;
            $[65] = t12;
        } else t12 = $[65];
        return t12;
    }
    if ("application/vnd.oasis.opendocument.spreadsheet" === blobType) {
        const t9 = isTablet ? 56 : 36;
        const t10 = isTablet ? 56 : 36;
        let t11;
        if ($[66] !== t10 || $[67] !== t9) {
            t11 = /*#__PURE__*/ jsx(OdsFileImage, {
                width: t9,
                height: t10
            });
            $[66] = t10;
            $[67] = t9;
            $[68] = t11;
        } else t11 = $[68];
        let t12;
        if ($[69] !== onClickDownload || $[70] !== shape || $[71] !== t11 || $[72] !== withCollapsableFooter) {
            t12 = /*#__PURE__*/ jsx(DownloadableFileIcon, {
                shape: shape,
                onClickDownload: onClickDownload,
                withCollapsableFooter: withCollapsableFooter,
                children: t11
            });
            $[69] = onClickDownload;
            $[70] = shape;
            $[71] = t11;
            $[72] = withCollapsableFooter;
            $[73] = t12;
        } else t12 = $[73];
        return t12;
    }
    if ("application/pkcs7-mime" === blobType || (null == blob ? void 0 : null == (_blob_path = blob.path) ? void 0 : _blob_path.endsWith(".p7m"))) {
        const t9 = isTablet ? 56 : 36;
        const t10 = isTablet ? 56 : 36;
        let t11;
        if ($[74] !== t10 || $[75] !== t9) {
            t11 = /*#__PURE__*/ jsx(P7mFileImage, {
                width: t9,
                height: t10
            });
            $[74] = t10;
            $[75] = t9;
            $[76] = t11;
        } else t11 = $[76];
        let t12;
        if ($[77] !== onClickDownload || $[78] !== shape || $[79] !== t11 || $[80] !== withCollapsableFooter) {
            t12 = /*#__PURE__*/ jsx(DownloadableFileIcon, {
                shape: shape,
                onClickDownload: onClickDownload,
                withCollapsableFooter: withCollapsableFooter,
                children: t11
            });
            $[77] = onClickDownload;
            $[78] = shape;
            $[79] = t11;
            $[80] = withCollapsableFooter;
            $[81] = t12;
        } else t12 = $[81];
        return t12;
    }
    if ("text/csv" === blobType || "application/csv" === blobType) {
        const t9 = isTablet ? 56 : 36;
        const t10 = isTablet ? 56 : 36;
        let t11;
        if ($[82] !== t10 || $[83] !== t9) {
            t11 = /*#__PURE__*/ jsx(CsvFileImage, {
                width: t9,
                height: t10
            });
            $[82] = t10;
            $[83] = t9;
            $[84] = t11;
        } else t11 = $[84];
        let t12;
        if ($[85] !== onClickDownload || $[86] !== shape || $[87] !== t11 || $[88] !== withCollapsableFooter) {
            t12 = /*#__PURE__*/ jsx(DownloadableFileIcon, {
                shape: shape,
                onClickDownload: onClickDownload,
                withCollapsableFooter: withCollapsableFooter,
                children: t11
            });
            $[85] = onClickDownload;
            $[86] = shape;
            $[87] = t11;
            $[88] = withCollapsableFooter;
            $[89] = t12;
        } else t12 = $[89];
        return t12;
    }
    if ("application/msword" === blobType || "application/vnd.openxmlformats-officedocument.wordprocessingml.document" === blobType) {
        const t9 = isTablet ? 56 : 36;
        const t10 = isTablet ? 56 : 36;
        let t11;
        if ($[90] !== t10 || $[91] !== t9) {
            t11 = /*#__PURE__*/ jsx(DocFileImage, {
                width: t9,
                height: t10
            });
            $[90] = t10;
            $[91] = t9;
            $[92] = t11;
        } else t11 = $[92];
        let t12;
        if ($[93] !== onClickDownload || $[94] !== shape || $[95] !== t11 || $[96] !== withCollapsableFooter) {
            t12 = /*#__PURE__*/ jsx(DownloadableFileIcon, {
                shape: shape,
                onClickDownload: onClickDownload,
                withCollapsableFooter: withCollapsableFooter,
                children: t11
            });
            $[93] = onClickDownload;
            $[94] = shape;
            $[95] = t11;
            $[96] = withCollapsableFooter;
            $[97] = t12;
        } else t12 = $[97];
        return t12;
    }
    if ("application/pgp-signature" === blobType || (null == blob ? void 0 : null == (_blob_path1 = blob.path) ? void 0 : _blob_path1.endsWith(".sig"))) {
        let t9;
        if ($[98] === Symbol.for("react.memo_cache_sentinel")) {
            t9 = /*#__PURE__*/ jsx(Box, {
                children: /*#__PURE__*/ jsx(Box, {
                    px: "32",
                    py: "48",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    children: /*#__PURE__*/ jsx(Icon, {
                        name: "vkhrtek_sig_file",
                        color: "original.brand.primary",
                        size: "48"
                    })
                })
            });
            $[98] = t9;
        } else t9 = $[98];
        return t9;
    }
    if ("application/vnd.ms-excel" === blobType || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" === blobType) {
        const t9 = isTablet ? 56 : 36;
        const t10 = isTablet ? 56 : 36;
        let t11;
        if ($[99] !== t10 || $[100] !== t9) {
            t11 = /*#__PURE__*/ jsx(ExcelFileImage, {
                width: t9,
                height: t10
            });
            $[99] = t10;
            $[100] = t9;
            $[101] = t11;
        } else t11 = $[101];
        let t12;
        if ($[102] !== onClickDownload || $[103] !== shape || $[104] !== t11 || $[105] !== withCollapsableFooter) {
            t12 = /*#__PURE__*/ jsx(DownloadableFileIcon, {
                shape: shape,
                onClickDownload: onClickDownload,
                withCollapsableFooter: withCollapsableFooter,
                children: t11
            });
            $[102] = onClickDownload;
            $[103] = shape;
            $[104] = t11;
            $[105] = withCollapsableFooter;
            $[106] = t12;
        } else t12 = $[106];
        return t12;
    }
    const t9 = isTablet ? 56 : 36;
    const t10 = isTablet ? 56 : 36;
    let t11;
    if ($[107] !== t10 || $[108] !== t9) {
        t11 = /*#__PURE__*/ jsx(UnknownFileImage, {
            width: t9,
            height: t10
        });
        $[107] = t10;
        $[108] = t9;
        $[109] = t11;
    } else t11 = $[109];
    let t12;
    if ($[110] !== onClickDownload || $[111] !== shape || $[112] !== t11 || $[113] !== withCollapsableFooter) {
        t12 = /*#__PURE__*/ jsx(DownloadableFileIcon, {
            shape: shape,
            onClickDownload: onClickDownload,
            withCollapsableFooter: withCollapsableFooter,
            children: t11
        });
        $[110] = onClickDownload;
        $[111] = shape;
        $[112] = t11;
        $[113] = withCollapsableFooter;
        $[114] = t12;
    } else t12 = $[114];
    return t12;
};
export { FilePreviewContent };
